import { Popover } from "antd";

export const PopOver = ({ children, title, button }) => {
  return (
    <Popover
      placement="bottomRight"
      content={children}
      title={title}
      trigger="click"
    >
      {button}
    </Popover>
  );
};
